export default __webpack_public_path__ + "static/treatmentareas_legsbefore-b4e589c9d0d0493a5b410db5218683ad.webp";